import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api';
import { Loading } from '../../ui/bits';
import { SceneError } from '../art';
import { clock, dayStamp } from '../../lib/format.js';
import { ACTION_LABEL, auditActor, auditChanges } from '../lib/list.js';
import { catalogKeys } from '../keys';

/** Who changed what (product_audit, newest first). Loads when opened. */
export function HistoryPanel({ shopId, productId, updatedAt }: { shopId: string; productId: string; updatedAt: string }) {
  const [open, setOpen] = useState(false);
  const audit = useQuery({
    queryKey: [...catalogKeys.audit(shopId, productId), updatedAt],
    queryFn: () => api.productAudit(shopId, productId),
    enabled: open,
  });
  return (
    <section className="card panel">
      <details onToggle={(e) => setOpen((e.currentTarget as HTMLDetailsElement).open)}>
        <summary className="cat-summary">
          <h2>History</h2>
        </summary>
        <div className="stack s12 cat-history">
          {audit.isError ? (
            <SceneError error={audit.error} onRetry={() => void audit.refetch()} compact />
          ) : !audit.data ? (
            <Loading label="Loading history" />
          ) : audit.data.length === 0 ? (
            <p className="t-caption muted">No changes recorded yet.</p>
          ) : (
            <ol className="stack s12">
              {audit.data.map((e) => {
                const at = new Date(e.at);
                const changes = auditChanges(e);
                return (
                  <li key={e.id} className="cat-audit">
                    <div className="row between wrap">
                      <b className="t-label">{ACTION_LABEL[e.action] ?? e.action}</b>
                      <span className="t-monocap muted">
                        <time dateTime={e.at}>{Number.isNaN(at.getTime()) ? '—' : `${dayStamp(at)} · ${clock(at)}`}</time>
                      </span>
                    </div>
                    <span className="t-caption muted">{auditActor(e)}</span>
                    {changes.length ? (
                      <ul className="stack s4">
                        {changes.map((c) => (
                          <li key={c.key} className="t-caption">
                            {c.label}: <span className="muted">{c.from}</span> → {c.to}
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </details>
    </section>
  );
}
